import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

export const INITIAL_STATE = Immutable({
  success: false,
  loading: false,
  loaded: false,
  searchAttempt: 0,
  searchText: '',
  items: undefined,
  error: {},
  alterItems: [],
})

const { Types, Creators } = createActions({
  searchItems: ['merchantKey', 'searchText'],
  searchItemSuccess: ['items'],
  searchItemError: ['errors'],

  updateAlterItems: ['merchantKey'],
  updateAlterItemSuccess: [],
  updateAlterItemError: ['errors'],

  addItem: ['item', 'itemKey'],
  removeItem: ['itemKey'],
})

export const searchItemRequestReducer = (state, { searchText }) =>
  state
    .set('loading', true)
    .set('loaded', false)
    .set('searchAttempt', state.searchAttempt + 1)
    .set('searchText', searchText)
export const searchItemSuccessReducer = (state, { items }) => {
  return state
    .set('loading', false)
    .set('loaded', true)
    .set('success', true)
    .set('searchText', '')
    .set('items', items)
}

export const searchItemErrorReducer = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const updateAlterItemReducer = state => state.set('loading', true)
export const updateAlterItemSuccessReducer = state =>
  state
    .set('loading', false)
    .set('items', undefined)
    .set('alterItems', [])
export const updateAlterItemErrorReducer = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const addItemReducer = (state, { item, itemKey }) => {
  const foundItem = state.alterItems.find(i => i.key === itemKey) || undefined
  const items = foundItem
    ? state.alterItems.map(i => (i.key === itemKey ? item : i))
    : [...state.alterItems, item]
  return state.set('alterItems', items)
}
export const removeItemReducer = (state, { itemKey }) =>
  state.set('alterItems', _.filter(state.alterItems, item => item.key !== itemKey))

export const hasuraSearchItemReducer = createReducer(INITIAL_STATE, {
  [Types.SEARCH_ITEMS]: searchItemRequestReducer,
  [Types.SEARCH_ITEM_SUCCESS]: searchItemSuccessReducer,
  [Types.SEARCH_ITEM_ERROR]: searchItemErrorReducer,

  [Types.UPDATE_ALTER_ITEMS]: updateAlterItemReducer,
  [Types.UPDATE_ALTER_ITEM_SUCCESS]: updateAlterItemSuccessReducer,
  [Types.UPDATE_ALTER_ITEM_ERROR]: updateAlterItemErrorReducer,

  [Types.ADD_ITEM]: addItemReducer,
  [Types.REMOVE_ITEM]: removeItemReducer,
})

export const HasuraSearchItemTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/hasuraSearchItemReducer.js